import coordination from '@/locales/es/coordination/coordination.locales';

export default {
    ...coordination,
};
